var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "registration-form validate-phone",
      attrs: { action: _vm.action, method: "POST" }
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "_token" },
        domProps: { value: _vm.csrkToken }
      }),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "profil-form profil-form-mobile" },
        [
          _c("md-card-content", [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("registration.validate-phone.title")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t("registration.validate-phone.description", {
                      phone: _vm.user.phone
                    })
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "code" },
              [
                _c(
                  "md-field",
                  { class: { "md-invalid": !!_vm.errors.code } },
                  [
                    _c("md-input", {
                      attrs: {
                        autocomplete: "one-time-code",
                        name: "phone_confirmation",
                        disabled: _vm.submitting ? "disabled" : null,
                        required: ""
                      },
                      model: {
                        value: _vm.fData.code,
                        callback: function($$v) {
                          _vm.$set(_vm.fData, "code", $$v)
                        },
                        expression: "fData.code"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "md-error" }, [
                      _vm._v(_vm._s(_vm.errors.code ? _vm.errors.code[0] : ""))
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "resend" }, [
              _c("span", { on: { click: _vm.resendCode } }, [
                _c("u", [
                  _vm._v(
                    _vm._s(_vm.$t("registration.validate-phone.resend-code"))
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row form-row-submit" }, [
            _c(
              "div",
              { staticClass: "form-submit-button" },
              [
                _c("submit-button", {
                  staticClass: "registration-standalone-button",
                  attrs: {
                    type: "submit",
                    submitting: _vm.submitting,
                    label: _vm.$t("registration.validate-phone.confirm"),
                    dusk: "submit-profile-button"
                  },
                  on: {
                    click: function($event) {
                      _vm.onSubmit()
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-snackbar",
        {
          attrs: { "md-active": _vm.showSnackbar },
          on: {
            "update:mdActive": function($event) {
              _vm.showSnackbar = $event
            }
          }
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("registration.validate-phone.resend-code-snackbar"))
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-041a4f8f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-041a4f8f","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/formValidatePhone.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-041a4f8f","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/formValidatePhone.vue
// module chunks = 1 2 3